module.exports = __webpack_public_path__ + "static/assets/be8facea9ea35bb0caec2b1e7f175dee.svg";